import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { Puzzle } from './puzzle.js';
import { vec3 } from 'gl-matrix';

const tempVec = vec3.create();

export class ColumnAnimator extends Component {
    static TypeName = 'column-animator';

    @property.object({ required: true })
    puzzleObject!: Object3D;

    @property.float(40)
    jiggleFrequency = 40;

    @property.float(0.03)
    jiggleAmplitude = 0.03;

    @property.float(1)
    waveFrequency = 1;

    @property.float(0.15)
    waveAmplitude = 0.15;

    private _puzzle: Puzzle;
    private _time: number = 0;
    start() {
        this._puzzle = this.puzzleObject.getComponent(Puzzle);
    }

    update(dt: number) {
        this._time += dt;
        for (let x = 0; x < this._puzzle.lanes.length; x++) {
            const waveOffset =
                Math.sin(this._time * this.waveFrequency + x) *
                this.waveAmplitude;
            if (this._puzzle.moveUpSoon) {
                this._puzzle.lanes[x].getPositionLocal(tempVec);
                tempVec[1] =
                    Math.sin(this._time * this.jiggleFrequency) *
                        this.jiggleAmplitude +
                    waveOffset;
                this._puzzle.lanes[x].setPositionLocal(tempVec);
            } else {
                this._puzzle.lanes[x].getPositionLocal(tempVec);
                tempVec[1] = waveOffset;
                this._puzzle.lanes[x].setPositionLocal(tempVec);
            }
        }
    }
}
